import React, { useState, useEffect } from "react";

import "./orderSuccess.css";

import Locations from "../../data/locations.json";

import OrderSubmitted from "./components/OrderSubmitted";
import Map from "../select-location/components/Map";

import Image from "../../images/cafe-drink.jpeg";

import { useCountdown } from "../../hooks/useCountDown";
import { useOrder } from "../../contexts/OrderContext";

import { useAuth } from "../../contexts/AuthContext";

import { useNavigate } from "react-router-dom";
import Loader from "../commonComponents/Loader/Loader";

import { toast } from "react-toastify";

export default function OrderSuccess() {
  // const [allLocations, setAllLocations] = useState(Locations.data);
  const [isLoading, setIsLoading] = useState(true);
  const [minutes, seconds, setTargetDate] = useCountdown(0);
  const [orderResult, setOrderResult] = useState({
    status: 0,
  });
  const { setCartInfo } = useOrder();
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  // const [selectedLocationId, setSelectedLocationId] = useState(5);
  // useEffect(() => {
  //   fetch("https://api.redfoxcafe.ir/v1/client/deliver-locations/", {
  //     method: "GET",
  //   })
  //     .then((response) => response.json())
  //     .then((d) => setAllLocations(d.data));
  // }, []);

  useEffect(() => {
    const getData = async () => {
      await fetch("https://api.redfoxcafe.ir/v1/client/active-cart/", {
        method: "GET",
        headers: {
          "Authorization-Token": "Bearer " + currentUser.access_token,
        },
      })
        .then((response) => response.json())
        .then((d) => {
          if (d.status === "200") {
            const cartStatus = Number(d.data.CartStatusNumber);
            if (cartStatus < 4 || cartStatus === 7) {
              setIsLoading(false);
              const newInfo = {
                cartId: d.data.CartId,
                products: d.data.CartDetails ? d.data.CartDetails : [],
                status: d.data.CartStatusNumber,
              };
              setCartInfo(newInfo);
              navigate("/");
            } else {
              setOrderResult({
                status: cartStatus,
              });
              setIsLoading(false);
              if (cartStatus === 5) {
                setTargetDate(Number(d.data.InvoiceDuration));
              }
            }
          }
        });
    };
    const interval = setInterval(() => getData(), 5000);
    return () => clearInterval(interval);
  }, [orderResult]);

  return (
    // selectedLocationId &&
    // allLocations.length !== 0 && (
    <div className="upper-container location-container">
      {
        isLoading ? (
          <Loader loading={isLoading} style={{ gridColumn: "span 2" }} />
        ) : (
          <OrderSubmitted
            remainingMinutes={minutes}
            remainingSeconds={seconds}
            showTime={orderResult.status === 5}
          />
        )
        /* <div className="location-map">
            <Map data={allLocations} selectedId={selectedLocationId} />
          </div> */
      }
      <div className="order-result-img"></div>
    </div>
  );
}
